<vw-toast-popup [isOpen]="isOpen" width="100%" borderRadius="20px" customClass="bg-white" (close)="onClose()">
  <div class="mt-4">
    <vw-custom-form [isOpen]="isOpen" [formConfig]="formConfig" [formData]="formData"
      (submitForm)="onFormSubmitted($event)" [loading]="editUserLoading"></vw-custom-form>
  </div>
</vw-toast-popup>